// Localization (spec/dashboard.md sections 9.1–9.6): the route-bound tabs Strings · Groups · Settings · Report, the string
// drawer (`?string=<id>`) on every tab, and the import / export dialog (`?dialog=import | export`).
import { Navigate, useLocation, useParams } from 'react-router';
import { useContent } from '../../content/ContentContext';
import { ImportExportDialog } from '../../content/dialogs/ImportExportDialog';
import { useGame } from '../../shell/GameContext';
import { routes } from '../../shell/routes';
import { Tabs } from '../../ui/Tabs';
import { useUrlParam } from '../../ui/Modal';
import { GroupsTab } from './GroupsTab';
import { ReportTab } from './ReportTab';
import { SettingsTab } from './SettingsTab';
import { StringDrawer } from './StringDrawer';
import { StringsTab } from './StringsTab';
import './localization.css';

const TABS = [
  { key: 'strings', label: 'Strings' },
  { key: 'groups', label: 'Groups' },
  { key: 'settings', label: 'Settings' },
  { key: 'report', label: 'Report' },
] as const;

export function LocalizationPage() {
  const { org, game } = useGame();
  const { branch = '', tab } = useParams();
  const location = useLocation();
  const stringParam = useUrlParam('string');
  const groupParam = useUrlParam('group');
  const catalog = useContent();
  if (!tab || !TABS.some((t) => t.key === tab)) return <Navigate to={routes.branch(org, game.slug, branch, 'localization/strings') + location.search} replace />;
  return (
    <section className="loc-page">
      <div className="page-head">
        <h1>Localization</h1>
        {!catalog.loading && (
          <span className="page-meta">
            {catalog.stringList.length} string{catalog.stringList.length === 1 ? '' : 's'} · {catalog.languages.length} language{catalog.languages.length === 1 ? '' : 's'}
          </span>
        )}
      </div>
      <Tabs ariaLabel="Localization" items={TABS.map((t) => ({ key: t.key, label: t.label, to: routes.branch(org, game.slug, branch, `localization/${t.key}`) }))} />
      <div className="loc-tab">
        {tab === 'strings' && <StringsTab />}
        {tab === 'groups' && <GroupsTab />}
        {tab === 'settings' && <SettingsTab />}
        {tab === 'report' && <ReportTab />}
      </div>
      {stringParam.value && <StringDrawer id={stringParam.value} onClose={stringParam.close} />}
      <ImportExportDialog layout="localization" group={groupParam.value} />
    </section>
  );
}
